import { HttpClient } from '@angular/common/http';
import { computed, inject, Injectable, resource } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

type FeatureFlags = {
    api_keys: boolean;
    pwa: boolean;
    github: boolean;
    usage_chart_phase_1: boolean;
    corporate_workspaces_phase_2: boolean;
    member_connector_controls: boolean;
    user_profile_photo_upload: boolean;
};

const DEFAULT_FEATURE_FLAGS: FeatureFlags = {
    api_keys: true,
    pwa: false,
    github: false,
    usage_chart_phase_1: false,
    corporate_workspaces_phase_2: false,
    member_connector_controls: false,
    user_profile_photo_upload: false,
};

@Injectable({ providedIn: 'root' })
export class FeatureFlagsService {
    private readonly http = inject(HttpClient);

    private readonly _flags = resource<FeatureFlags, unknown>({
        loader: (): Promise<FeatureFlags> =>
            firstValueFrom(this.http.get<FeatureFlags>(`${environment.apiBase}/features`)).catch(() => DEFAULT_FEATURE_FLAGS),
    });

    readonly apiKeysEnabled = computed(() => this._flags.value()?.api_keys ?? true);
    readonly pwaEnabled = computed(() => this._flags.value()?.pwa ?? false);
    readonly githubEnabled = computed(() => this._flags.value()?.github ?? false);
    readonly usageChartPhase1Enabled = computed(() => this._flags.value()?.usage_chart_phase_1 ?? false);
    readonly corporateWorkspacesPhase2Enabled = computed(() => this._flags.value()?.corporate_workspaces_phase_2 ?? false);
    readonly memberConnectorControlsEnabled = computed(() => this._flags.value()?.member_connector_controls ?? false);
    readonly profilePhotoUploadEnabled = computed(() => this._flags.value()?.user_profile_photo_upload ?? false);
}
